import { actionNames, actionPrefixes } from "@newsela/snitch";
import { useState } from "react";

import ExportablesBaseModal from "@/components/AIComponents/ExportablesModal/ExportablesBaseModal";
import ExportablesModalContext, {
  type ExportablesModalCommonProps,
} from "@/components/AIComponents/ExportablesModal/ExportablesModalContext";
import { useExportablesModalContext } from "@/components/AIComponents/ExportablesModal/ExportablesModalContext/useExportablesModalContext";
import { ASSESSMENT_TYPE } from "@/types/models";
import ViewableActivity from "@/view/TeacherActivityContainer/ViewableActivity";

interface TeacherProps extends ExportablesModalCommonProps {
  dispatch: () => void;
  setVisibleActivityIds: () => void;
  visibleActivityIds: string[];
}

const TeacherComponent = ({
  dispatch,
  setVisibleActivityIds,
  visibleActivityIds,
}: {
  dispatch: () => void;
  setVisibleActivityIds: () => void;
  visibleActivityIds: string[];
}) => {
  const { content, levelId } = useExportablesModalContext();

  // TODO: this will be replaced when we integrate with the assignment state
  const [isGraphicOrganizerActive] = useState(false);

  const checkboxQaSelector = isGraphicOrganizerActive
    ? "remove-graphic-organizer-activity-from-assignment"
    : "add-graphic-organizer-activity-to-assignment";

  const {
    handleTemplateSelection,
    modalTriggerRef,
    isContentSupported,
    isInAssignGraphicOrganizersExperiment,
  } = useExportablesModalContext();

  const eventProperties = {
    // TODO: add "GraphicOrganizer" to objectTypes on snitch
    objectType: "GraphicOrganizer",
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.interact,
    ref: modalTriggerRef,
    streamProperties: {
      content_type: content.content_type,
      content_id: levelId,
      description: "Open modal for exportable resources",
    },
  };

  const handleClick = () => {
    handleTemplateSelection();
  };

  if (!isContentSupported || !isInAssignGraphicOrganizersExperiment)
    return null;

  return (
    <>
      <ViewableActivity
        assessmentType={ASSESSMENT_TYPE.GRAPHIC_ORGANIZERS}
        buttonDataProps={{
          "data-qa-selector": "open-exportables-modal-button",
        }}
        checkboxDataProps={{ "data-qa-selector": checkboxQaSelector }}
        dispatch={dispatch}
        isSelected={isGraphicOrganizerActive}
        label="Graphic Organizers"
        onClick={handleClick}
        eventProperties={eventProperties}
        setVisibleActivityIds={setVisibleActivityIds}
        visibleActivityIds={visibleActivityIds}
      />

      <ExportablesBaseModal isStudent={false} />
    </>
  );
};

const TeacherComponentWithContext = ({
  content,
  contentMetadata = [],
  currentLevel,
  dispatch,
  levelId,
  setVisibleActivityIds,
  visibleActivityIds,
}: TeacherProps) => {
  return (
    <ExportablesModalContext
      content={content}
      isStudent={false}
      contentMetadata={contentMetadata}
      currentLevel={currentLevel}
      levelId={levelId}
    >
      <TeacherComponent
        dispatch={dispatch}
        setVisibleActivityIds={setVisibleActivityIds}
        visibleActivityIds={visibleActivityIds}
      />
    </ExportablesModalContext>
  );
};

export default TeacherComponentWithContext;
